import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Team } from '../../teams/team.interface';

export class TeamService {
   async getTeams(userId: number, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Team>>>(`/users/${userId}/teams`, { params: { ...query } });
      return response.data;
   }

   async getTeam() {
      throw Error('Method not implemented');
   }

   async postTeam() {
      throw Error('Method not implemented');
   }

   async putTeam() {
      throw Error('Method not implemented');
   }

   async deleteTeam() {
      throw Error('Method not implemented');
   }

   async addUserTeams(userId: number, teams: Array<Team>) {
      const response = await http.post<Array<Team>>(`/users/${userId}/teams-batch`, { teams });
      return response.data;
   }

   async removeUserTeams(userId: number, teams: Array<Team>) {
      const response = await http.delete<Array<number>>(`/users/${userId}/teams-batch`, { data: { teams } });
      return response.data;
   }
}
